/**
 * col.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/4 下午8:59
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Col
 * */
export default function Col(props) {
    const { prefixCls, size, offset, order, align, children, className, colStyle = {}, style = {} } = props;

    const classes = classNames(
        prefixCls,
        {
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-offset-${offset}`]: offset,
            [`${prefixCls}-order-${order}`]: order,
            [`${prefixCls}-align-${align}`]: align,
        },
        className,
    );

    return (
        <div className={classes} style={{ ...colStyle, ...style }}>
            {children}
        </div>
    );
}

Col.propTypes = {
    /** 栅格左侧的间隔格数，间隔内不可以有栅格 */
    offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** 栅格的占位格数，可选值为0~24的整数，为 0 时，相当于display:none */
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** 栅格的顺序 */
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** 垂直对齐 */
    align: PropTypes.oneOf(['top', 'bottom', 'middle', 'stretch']),
    /** @ignore */
    colStyle: PropTypes.object,
    /** 样式 */
    style: PropTypes.object,
    /** 样式 */
    className: PropTypes.string,
};

Col.defaultProps = {
    prefixCls: 'column',
};

Col.displayName = 'NeatUI.Col';



// WEBPACK FOOTER //
// ./src/grid/Col.jsx